<template>
	<section class="container" :aria-label="userIsLogged ? 'Využijte své členství naplno' : 'Můj Globus'">
		<div class="rounded-3xl shadow-lg overflow-hidden bg-gradient-mujglobus p-4 sm:p-10">
			<div class="flex items-center justify-between mb-4 sm:mb-8">
				<NuxtImg src="/images/muj-globus.svg" class="rem:w-[123px] rem:md:w-[150px]" alt="" />
				<div class="hidden md:flex gap-4">
					<template v-if="userIsLogged">
						<AbsoluteInternalLink
							:to="{name: 'muj-ucet'}"
							class="btn btn-secondary btn-sm sm:btn-lg shadow-xs sm:whitespace-nowrap"
						>
							<NuxtIcon name="user" class="text-[1.25rem] text-icon-primary" filled />
							Otevřít Můj Globus účet
						</AbsoluteInternalLink>
					</template>
					<template v-else>
						<CrmRedirectButton class="btn btn-secondary btn-lg shadow-xs sm:whitespace-nowrap" :user-state="UserState.HP_MY_GLOBUS_BANNER_REGISTRATION">
							<NuxtIcon name="custom/myGlobus" class="text-[1.5rem] text-icon-primary" filled />
							Zaregistrovat
						</CrmRedirectButton>
						<CrmRedirectButton class="btn btn-secondary btn-lg shadow-xs sm:whitespace-nowrap" :user-state="UserState.HP_MY_GLOBUS_BANNER_LOGIN">
							<NuxtIcon name="user" class="text-[1.25rem] text-icon-primary" filled />
							Přihlásit
						</CrmRedirectButton>
					</template>
				</div>
			</div>
			<div class="bg-white rounded-3xl p-4 sm:p-10">
				<template v-if="userIsLogged">
					<h2 class="text-heading-primary typo-body-xl font-bold mb-4">
						Využijte své členství naplno
					</h2>
					<p class="typo-body-m text-body-primary">
						Připravte se na svůj další nákup v&nbsp;Globusu díky přehledu aktuálních slev a&nbsp;odměn. Zkontrolovat můžete také výši útraty nebo archiv elektronických účtenek.
					</p>
				</template>
				<div v-else class="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-x-10">
					<div>
						<NuxtImg
							width="100"
							height="100"
							src="/images/vernostni-program/dot-my-globus.png"
							alt="Moje nejvýhodnější ceny"
						/>
						<h3 class="typo-body-xl font-bold my-4">
							Moje nejvýhodnější ceny
						</h3>
						<p>Na produkty označené Můj Globus získáte ještě větší slevu.</p>
					</div>
					<div>
						<NuxtImg
							width="100"
							height="100"
							src="/images/vernostni-program/dot-kc.svg"
							alt="Moje odměny za nákupy"
						/>
						<h3 class="typo-body-xl font-bold my-4">
							Moje odměny za&nbsp;nákupy
						</h3>
						<p>S každým nákupem se přiblížíte ještě lepším odměnám.</p>
					</div>
					<div>
						<NuxtImg
							width="100"
							height="100"
							src="/images/vernostni-program/dot-gift.svg"
							alt="Moje slevové kupony"
						/>
						<h3 class="typo-body-xl font-bold my-4">
							Moje slevové kupony
						</h3>
						<p>Pravidelně získáte nové kupony.</p>
					</div>
					<div>
						<NuxtImg
							width="100"
							height="100"
							src="/images/vernostni-program/dot-sale.svg"
							alt="10% sleva k narozeninám"
						/>
						<h3 class="typo-body-xl font-bold my-4">
							10% sleva k&nbsp;narozeninám
						</h3>
						<p>Dáme vám narozeninový dárek 10 % slevu na celý nákup.</p>
					</div>
				</div>
			</div>
			<div class="flex gap-4 md:hidden w-full mt-4">
				<template v-if="userIsLogged">
					<AbsoluteInternalLink
						:to="{name: 'muj-ucet'}"
						class="btn btn-secondary btn-sm sm:btn-lg shadow-xs sm:whitespace-nowrap grow justify-center"
					>
						<NuxtIcon name="user" class="text-[1rem] text-icon-primary" filled />
						Otevřít Můj Globus účet
					</AbsoluteInternalLink>
				</template>
				<template v-else>
					<CrmRedirectButton class="btn btn-secondary btn-sm sm:btn-lg shadow-xs sm:whitespace-nowrap grow justify-center" :user-state="UserState.HP_MY_GLOBUS_BANNER_REGISTRATION">
						<NuxtIcon name="custom/myGlobus" class="text-[1.5rem] text-icon-primary" filled />
						Zaregistrovat
					</CrmRedirectButton>
					<CrmRedirectButton class="btn btn-secondary btn-sm sm:btn-lg shadow-xs sm:whitespace-nowrap grow justify-center" :user-state="UserState.HP_MY_GLOBUS_BANNER_LOGIN">
						<NuxtIcon name="user" class="text-[1.25rem] text-icon-primary" filled />
						Přihlásit
					</CrmRedirectButton>
				</template>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
	import {storeToRefs} from 'pinia';
	import {useCustomerProfileStore} from '~/stores/customerProfile';
	import {UserState} from '~/stores/crmStateStore';

	const {userIsLogged} = storeToRefs(useCustomerProfileStore());
</script>
